module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.fdad0ca5.jpg";